// Module
var code = "<div id=\"preloader\" class=\"col-md-6 col-md-offset-3 text-center\"> <br/> <br/> <br/> <div class=\"cbp-loader\"></div> <h3 data-bind=\"restext: 'RetrievingData'\"></h3> </div>";
// Exports
export default code;